import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function Recaptcha(props) {
  const { onChangeRecaptcha, recaptchaRef } = props;

  return <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={'6Leu1yslAAAAADMaT243d0p0Zo1d3ohFTnR0KF-Y'} onChange={onChangeRecaptcha} />;
}
